<template>
  <div>
    <div class="px-2">
      <h4 class="text-center font-weight-bold">개인정보의 취급위탁</h4>
    </div>
    <div class="row justify-content-center">
      <p class="text-center">
        SK핀크스(주)는 수집된 개인정보의 취급 및 관리 등의 업무를 스스로 수행함을 원칙으로 하나<br />
        원활한 업무 처리를 위해 필요한 경우 업무의 일부 또는 전부를 선정한 다음 다음 아래의 위탁업체에 위탁할 수
        있습니다.
      </p>
    </div>
    <table class="table table-borderless mt-2">
      <thead align="center">
        <tr style="border-top: 2px solid; border-bottom: 1px solid #cfcfcf; background-color: #f3f3f3">
          <th style="width: 30%; border-right: 1px solid #cfcfcf">수탁자명</th>
          <th style="width: 70%">취급 위탁 업무</th>
        </tr>
      </thead>
      <tbody align="center">
        <tr style="border-bottom: 1px solid #cfcfcf">
          <td style="border-right: 1px solid #cfcfcf; background-color: #f3f3f3">
            <div>SK 네트웍스서비스㈜</div>
          </td>
          <td>
            <div>서버 네트워킹 서비스, 홈페이지 운영 관리 및 논리적 및 물리적 데이터 베이스 관리</div>
          </td>
        </tr>
        <tr style="border-bottom: 1px solid #cfcfcf">
          <td style="background-color: #f3f3f3; border-right: 1px solid #cfcfcf">
            <div>비즈톡 주식회사</div>
          </td>
          <td>
            <div>문자발송(SMS) 서비스</div>
          </td>
        </tr>
        <tr style="border-bottom: 1px solid">
          <td style="border-right: 1px solid #cfcfcf; background-color: #f3f3f3">
            <div>SCI 평가정보㈜</div>
          </td>
          <td>
            <div>아이핀/휴대폰을 통한 본인인증</div>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="px-2">취급위탁에 동의하지 않을 권리는 있으나, 미동의 시 서비스를 이용하실 수 없습니다.</p>
  </div>
</template>

<script>
export default {
  name: 'MemberPrivacyConsignment',
};
</script>

<style scoped lang="scss">
.table {
  th,
  td {
    font-size: 0.9rem;
    vertical-align: middle;
  }
}
ul {
  margin: 0rem;
  padding-left: 1.5rem;
}
p {
  //font-size: 0.9rem;
}
</style>
